import React from "react";

interface LimitSelectorProps {
  limit: number;
  setLimit: (limit: number) => void;
}

const LimitSelector: React.FC<LimitSelectorProps> = ({ limit, setLimit }) => {
  const handleLimitChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLimit = parseInt(event.target.value, 10);
    setLimit(newLimit);
  };

  return (
    <div className="flex gap-2 items-center">
      <span>Limit</span>
      <select
        className="px-[10px] py-[5px] rounded-md border"
        value={limit}
        onChange={handleLimitChange}
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={30}>30</option>
        <option value={40}>40</option>
        <option value={50}>50</option>
        <option value={60}>60</option>
        <option value={70}>70</option>
        <option value={80}>80</option>
        <option value={90}>90</option>
        <option value={100}>100</option>
        <option value={200}>200</option>
        <option value={300}>300</option>
        <option value={400}>400</option>
        <option value={500}>500</option>
      </select>
    </div>
  );
};

export default LimitSelector;
